"use client";

import { useEffect } from "react";

const SIGNUP_URL = "https://app.vawena.ai/signup";

/** Redirects to the main app sign-up page so vawena.ai/signup does not 404. */
export function SignupRedirect() {
  useEffect(() => {
    window.location.href = SIGNUP_URL;
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#020D30] text-white">
      <p className="text-white/80">Redirecting to sign up…</p>
    </div>
  );
}
